import { BADGES } from "../types/actions";

const initialState = {
    badgesResult: {},
    badgeDetails: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case BADGES.GET_BADGES:
			return {
				...state,
				badgesResult: action.payload
            };
		case BADGES.GET_BADGE_DETAILS:
            return {
                ...state,
                badgeDetails: action.payload
            };

		default:
			return state;
	}
};
